import React from 'react'
import './FloatingButton.css'

const FloatingButton = ({onClick}) => {
  return (
    <button className="floating-button" onClick={onClick}>
        <i className="bi bi-arrow-up-short"></i>
     </button>
  )
}

export default FloatingButton
